import { useState } from "react";
import SidebarAdmin from "./Sidebar";
import SidebarCliente from "./SidebarCliente";

export default function AppLayout({
  title,
  subtitle,
  children,
  role = "admin",
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0b0f19] text-slate-100">
    {role === "cliente" ? <SidebarCliente /> : <SidebarAdmin />}

      {/* CONTEÚDO */}
      <main className="lg:ml-64">
        {/* TOPO MOBILE */}
        <div className="sticky top-0 z-30 flex items-center gap-3 bg-[#0b0f19]/95 px-4 py-4 backdrop-blur lg:hidden">
          <button
            onClick={() => setOpen(true)}
            className="rounded-lg border border-[#1f2937] p-2 text-slate-300 hover:text-slate-100"
          >
            ☰
          </button>

          <div>
            <p className="text-base font-semibold">{title}</p>
            {subtitle && (
              <p className="text-xs text-slate-400">{subtitle}</p>
            )}
          </div>
        </div>

        {/* CONTEÚDO INTERNO */}
        <div className="mx-auto max-w-7xl px-6 py-8 lg:px-8 lg:py-10">
          {/* TOPO DESKTOP */}
          <header className="mb-8 hidden lg:block">
            <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
            {subtitle && (
              <p className="mt-2 text-base text-slate-400">{subtitle}</p>
            )}
          </header>

          {children}
        </div>
      </main>
    </div>
  );
}
